/* eslint-disable */
import CommonMC_en from './en/CommonMC.json';
import AdsCenter_en from './en/AdsCenter.json';
import CommonMC_es from './es/CommonMC.json';
import CommonMC_pt from './pt/CommonMC.json';
import AdsCenter_es from './es/AdsCenter.json';
import AcademyMC_en from './en/AcademyMC.json';
import AutomationShopify_en from './en/AutomationShopify.json';
import CampaignsScreenMC_en from './en/CampaignsScreenMC.json';
import CampaignsStatusScreenMC_en from './en/CampaignsStatusScreenMC.json';
import BusinessConfigScreenMC_en from './en/BusinessConfigScreenMC.json';
import Clients_en from './en/Clients.json';
import CustomerList_en from './en/CustomerList.json';
import CustomerRelatedFieldsMC_en from './en/CustomerRelatedFieldsMC.json';
import DigitalPayments_en from './en/DigitalPayments.json';
import CustomersScreenMC_en from './en/CustomersScreenMC.json';
import TeamAssignments_en from './en/TeamAssignments.json';
import ExportedCustomers_en from './en/ExportedCustomers.json';
import Funnels_en from './en/Funnels.json';
import InboxMC_en from './en/InboxMC.json';
import MyAccountScreenMC_en from './en/MyAccountScreenMC.json';
import MyTeam_en from './en/MyTeam.json';
import Orders_en from './en/Orders.json';
import RegistrationsMC_en from './en/RegistrationsMC.json';
import RemindersScreenMC_en from './en/RemindersScreenMC.json';
import ShippingScreenMC_en from './en/ShippingScreenMC.json';
import ShippingCostMC_en from './en/ShippingCostMC.json';
import WebhooksScreenMC_en from './en/WebhooksScreenMC.json';
import WhatsappFlowsScreenMC_en from './en/WhatsappFlowsScreenMC.json';
import StatusTagMC_en from './en/StatusTagMC.json';
import Tags_en from './en/Tags.json';
import campaigns_en from './en/campaigns.json';
import createCampaign_en from './en/createCampaign.json';
import AcademyMC_es from './es/AcademyMC.json';
import AutomationShopify_es from './es/AutomationShopify.json';
import CampaignsScreenMC_es from './es/CampaignsScreenMC.json';
import CampaignsStatusScreenMC_es from './es/CampaignsStatusScreenMC.json';
import BusinessConfigScreenMC_es from './es/BusinessConfigScreenMC.json';
import Clients_es from './es/Clients.json';
import CustomerList_es from './es/CustomerList.json';
import CustomerRelatedFieldsMC_es from './es/CustomerRelatedFieldsMC.json';
import DigitalPayments_es from './es/DigitalPayments.json';
import CustomersScreenMC_es from './es/CustomersScreenMC.json';
import TeamAssignments_es from './es/TeamAssignments.json';
import ExportedCustomers_es from './es/ExportedCustomers.json';
import Funnels_es from './es/Funnels.json';
import IntegrationsScreenMC_es from './es/IntegrationsScreenMC.json';
import MyAccountScreenMC_es from './es/MyAccountScreenMC.json';
import MyTeam_es from './es/MyTeam.json';
import Orders_es from './es/Orders.json';
import RegistrationsMC_es from './es/RegistrationsMC.json';
import RemindersScreenMC_es from './es/RemindersScreenMC.json';
import ShippingScreenMC_es from './es/ShippingScreenMC.json';
import ShippingCostMC_es from './es/ShippingCostMC.json';
import WebhooksScreenMC_es from './es/WebhooksScreenMC.json';
import WhatsappFlowsScreenMC_es from './es/WhatsappFlowsScreenMC.json';
import StatusTagMC_es from './es/StatusTagMC.json';
import Tags_es from './es/Tags.json';
import campaigns_es from './es/campaigns.json';
import createCampaign_es from './es/createCampaign.json';
import integrations_en from './en/integrations.json';
import integrations_es from './es/integrations.json';
import integrations_pt from './pt/integrations.json';
import InboxMC_es from './es/InboxMC.json';
import translation_es from './es/translation.json';
import translation_en from './en/translation.json';
import Routes_es from './es/Routes.json';
import Routes_en from './en/Routes.json';
import whatsappIntegrations_en from './en/whatsappIntegrationsEN.json';
import whatsappIntegrations_es from './es/whatsappIntegrationsES.json';
import Inbox_es from './es/Inbox.json';
import Inbox_en from './en/Inbox.json';
import Inbox_pt from './pt/Inbox.json';
import InboxMC_pt from './pt/InboxMC.json';
import Widgets_es from './es/Widgets.json';
import Widgets_en from './en/Widgets.json';
import ConversationTopics_es from './es/ConversationTopicsES.json';
import ConversationTopics_en from './en/ConversationTopicsEN.json';
import ChatbotIA_es from './es/ChatbotIA.json';
import ChatbotIA_en from './en/ChatbotIA.json';
import ChatbotIA_pt from './pt/ChatbotIA.json';
import MiaOnboarding_es from './es/MiaOnboarding.json';
import MiaOnboarding_en from './en/MiaOnboarding.json';
import Products_en from './en/ProductsMC.json';
import Products_es from './es/ProductsMC.json';
import Products_pt from './pt/ProductsMC.json';
import MiaConversationsAttendedMC_es from './es/MiaConversationsAttendedMC.json';
import MiaConversationsAttendedMC_en from './en/MiaConversationsAttendedMC.json';
import WsTemplatesMC_en from './en/WsTemplatesMC.json';
import WsTemplatesMC_es from './es/WsTemplatesMC.json';
import Plans_es from './es/Plans.json';
import Plans_en from './en/Plans.json';
import Dashboard_es from './es/DashboardMC.json';
import Dashboard_en from './en/DashboardMC.json';
import BmVerificationMC_es from './es/BmVerificationMC.json';
import BmVerificationMC_en from './en/BmVerificationMC.json';
import BmVerificationMC_pt from './pt/BmVerificationMC.json';
import EmptyScreensMC_es from './es/EmptyScreensMC.json';
import EmptyScreensMC_en from './en/EmptyScreensMC.json';
import AuthMC_es from './es/AuthMC.json';
import AuthMC_en from './en/AuthMC.json';
import AuthMC_pt from './pt/AuthMC.json';
import BusinessConfigScreenMC_pt from './pt/BusinessConfigScreenMC.json';
import MyAccountScreenMC_pt from './pt/MyAccountScreenMC.json';
import ShippingScreenMC_pt from './pt/ShippingScreenMC.json';
import ShippingCostMC_pt from './pt/ShippingCostMC.json';
import translation_pt from './pt/translation.json';
import SecurityMC_es from './es/SecurityMC.json';
import SecurityMC_en from './en/SecurityMC.json';
import GetYourPlanScreen_es from './es/GetYourPlanScreen.json';
import GetYourPlanScreen_en from './en/GetYourPlanScreen.json';
import ErrorScreensMC_es from './es/ErrorScreensMC.json';
import ErrorScreensMC_en from './en/ErrorScreensMC.json';
import SalesChannels_es from './es/SalesChannelsMC.json';
import SalesChannels_en from './en/SalesChannelsMC.json';
import Locations_es from './es/Locations.json';
import Locations_en from './en/Locations.json';
import EditBusinessInfo_es from './es/EditBusinessInfo.json';
import EditBusinessInfo_en from './en/EditBusinessInfo.json';
import Domain_es from './es/Domain.json';
import Domain_en from './en/Domain.json';
import Schedules_es from './es/Schedules.json';
import Schedules_en from './en/Schedules.json';
import Contacts_es from './es/Contacts.json';
import Contacts_en from './en/Contacts.json';
import CustomFieldsMC_es from './es/CustomFieldsMC.json';
import CustomFieldsMC_en from './en/CustomFieldsMC.json';
import HelpCenter_es from './es/HelpCenter.json';
import HelpCenter_en from './en/HelpCenter.json';
import NewChat_es from './es/NewChat.json';
import NewChat_en from './en/NewChat.json';
import TeamSelectMC_es from './es/TeamSelectMC.json';
import TeamSelectMC_en from './en/TeamSelectMC.json';
import WsTemplateTypeSelectMC_es from './es/WsTemplateTypeSelectMC.json';
import WsTemplateTypeSelectMC_en from './en/WsTemplateTypeSelectMC.json';
import FastAnswer_en from './en/FastAnswer.json';
import FastAnswer_es from './es/FastAnswer.json';
import PaymentPlans_es from './es/PaymentPlans.json';
import PaymentPlans_en from './en/PaymentPlans.json';
import PaymentPlans_pt from './pt/PaymentPlans.json';
import Messaging_es from './es/Messaging.json';
import Messaging_en from './en/Messaging.json';
import Fonema_en from './en/FonemaMC.json';
import Fonema_es from './es/FonemaMC.json';
import Fonema_pt from './pt/FonemaMC.json';
import CallEvent_en from './en/CallEventMC.json';
import CallEvent_es from './es/CallEventMC.json';
import CallEvent_pt from './pt/CallEventMC.json';
import CustomersScreenMC_pt from './pt/CustomersScreenMC.json';
import SalesDashboard_es from './es/SalesDashboard.json';
import SalesDashboard_en from './en/SalesDashboard.json';
import AppActions_en from './en/AppActions.json';
import AppActions_es from './es/AppActions.json';
import BrandsMC_en from './en/BrandsMC.json';
import BrandsMC_es from './es/BrandsMC.json';
import CategoriesMC_en from './en/CategoriesMC.json';
import CategoriesMC_es from './es/CategoriesMC.json';
import CalendarEventsScreenMC_en from './en/CalendarEventsScreenMC.json';
import CalendarEventsScreenMC_es from './es/CalendarEventsScreenMC.json';
import MarketingDashboard_en from './en/MarketingDashboard.json';
import MarketingDashboard_es from './es/MarketingDashboard.json';
import Quotes_en from './en/Quotes.json';
import Quotes_es from './es/Quotes.json';
import Quotes_pt from './pt/Quotes.json';

export const PATHS_LOCATIONS = {
  en: {
    Common: CommonMC_en,
    Academy: AcademyMC_en,
    AutomationShopify: AutomationShopify_en,
    BusinessConfigScreenMC: BusinessConfigScreenMC_en,
    CampaignsScreenMC: CampaignsScreenMC_en,
    CampaignsStatusScreenMC: CampaignsStatusScreenMC_en,
    Clients: Clients_en,
    CustomerList: CustomerList_en,
    CustomerRelatedFieldsMC: CustomerRelatedFieldsMC_en,
    DigitalPayments: DigitalPayments_en,
    CustomersScreenMC: CustomersScreenMC_en,
    TeamAssignments: TeamAssignments_en,
    ExportedCustomers: ExportedCustomers_en,
    Funnels: Funnels_en,
    InboxMC: InboxMC_en,
    MyAccountScreenMC: MyAccountScreenMC_en,
    MyTeam: MyTeam_en,
    Orders: Orders_en,
    RegistrationsMC: RegistrationsMC_en,
    RemindersScreenMC: RemindersScreenMC_en,
    ShippingScreenMC: ShippingScreenMC_en,
    ShippingCostMC: ShippingCostMC_en,
    WebhooksScreenMC: WebhooksScreenMC_en,
    WhatsappFlowsScreenMC: WhatsappFlowsScreenMC_en,
    StatusTagMC: StatusTagMC_en,
    Tags: Tags_en,
    campaigns: campaigns_en,
    createCampaign: createCampaign_en,
    translation: translation_en,
    integrations: integrations_en,
    Routes: Routes_en,
    whatsappIntegrations: whatsappIntegrations_en,
    Inbox: Inbox_en,
    Widgets: Widgets_en,
    ConversationTopics: ConversationTopics_en,
    ChatbotIA: ChatbotIA_en,
    MiaOnboarding: MiaOnboarding_en,
    Products: Products_en,
    MiaConversationsAttendedMC: MiaConversationsAttendedMC_en,
    WsTemplatesMC: WsTemplatesMC_en,
    Plans: Plans_en,
    Dashboard: Dashboard_en,
    BmVerificationMC: BmVerificationMC_en,
    EmptyScreensMC: EmptyScreensMC_en,
    AuthMC: AuthMC_en,
    Security: SecurityMC_en,
    GetYourPlanScreen: GetYourPlanScreen_en,
    ErrorScreensMC: ErrorScreensMC_en,
    NewChat: NewChat_en,
    TeamSelectMC: TeamSelectMC_en,
    WsTemplateTypeSelectMC: WsTemplateTypeSelectMC_en,
    FastAnswer: FastAnswer_en,
    SalesChannels: SalesChannels_en,
    HelpCenter: HelpCenter_en,
    Locations: Locations_en,
    EditBusinessInfo: EditBusinessInfo_en,
    Domain: Domain_en,
    Schedules: Schedules_en,
    Contacts: Contacts_en,
    CustomFieldsMC: CustomFieldsMC_en,
    PaymentPlans: PaymentPlans_en,
    Messaging: Messaging_en,
    CallEvent: CallEvent_en,
    Fonema: Fonema_en,
    SalesDashboard: SalesDashboard_en,
    AppActions: AppActions_en,
    AdsCenter: AdsCenter_en,
    MarketingDashboard: MarketingDashboard_en,
    BrandsMC: BrandsMC_en,
    CategoriesMC: CategoriesMC_en,
    CalendarEventsScreenMC: CalendarEventsScreenMC_en,
    Quotes: Quotes_en
  },
  es: {
    Common: CommonMC_es,
    Academy: AcademyMC_es,
    AutomationShopify: AutomationShopify_es,
    BusinessConfigScreenMC: BusinessConfigScreenMC_es,
    CampaignsScreenMC: CampaignsScreenMC_es,
    CampaignsStatusScreenMC: CampaignsStatusScreenMC_es,
    Clients: Clients_es,
    CustomerList: CustomerList_es,
    CustomerRelatedFieldsMC: CustomerRelatedFieldsMC_es,
    DigitalPayments: DigitalPayments_es,
    CustomersScreenMC: CustomersScreenMC_es,
    TeamAssignments: TeamAssignments_es,
    ExportedCustomers: ExportedCustomers_es,
    Funnels: Funnels_es,
    InboxMC: InboxMC_es,
    MyAccountScreenMC: MyAccountScreenMC_es,
    IntegrationsScreenMC: IntegrationsScreenMC_es,
    MyTeam: MyTeam_es,
    Orders: Orders_es,
    RegistrationsMC: RegistrationsMC_es,
    RemindersScreenMC: RemindersScreenMC_es,
    ShippingScreenMC: ShippingScreenMC_es,
    ShippingCostMC: ShippingCostMC_es,
    WebhooksScreenMC: WebhooksScreenMC_es,
    WhatsappFlowsScreenMC: WhatsappFlowsScreenMC_es,
    StatusTagMC: StatusTagMC_es,
    Tags: Tags_es,
    campaigns: campaigns_es,
    createCampaign: createCampaign_es,
    integrations: integrations_es,
    translation: translation_es,
    Routes: Routes_es,
    whatsappIntegrations: whatsappIntegrations_es,
    Inbox: Inbox_es,
    Widgets: Widgets_es,
    ConversationTopics: ConversationTopics_es,
    ChatbotIA: ChatbotIA_es,
    MiaOnboarding: MiaOnboarding_es,
    Products: Products_es,
    MiaConversationsAttendedMC: MiaConversationsAttendedMC_es,
    WsTemplatesMC: WsTemplatesMC_es,
    Plans: Plans_es,
    Dashboard: Dashboard_es,
    BmVerificationMC: BmVerificationMC_es,
    EmptyScreensMC: EmptyScreensMC_es,
    AuthMC: AuthMC_es,
    Security: SecurityMC_es,
    GetYourPlanScreen: GetYourPlanScreen_es,
    ErrorScreensMC: ErrorScreensMC_es,
    SalesChannels: SalesChannels_es,
    HelpCenter: HelpCenter_es,
    Locations: Locations_es,
    EditBusinessInfo: EditBusinessInfo_es,
    Domain: Domain_es,
    Schedules: Schedules_es,
    Contacts: Contacts_es,
    CustomFieldsMC: CustomFieldsMC_es,
    FastAnswer: FastAnswer_es,
    NewChat: NewChat_es,
    TeamSelectMC: TeamSelectMC_es,
    WsTemplateTypeSelectMC: WsTemplateTypeSelectMC_es,
    PaymentPlans: PaymentPlans_es,
    Messaging: Messaging_es,
    CallEvent: CallEvent_es,
    Fonema: Fonema_es,
    SalesDashboard: SalesDashboard_es,
    AppActions: AppActions_es,
    AdsCenter: AdsCenter_es,
    MarketingDashboard: MarketingDashboard_es,
    BrandsMC: BrandsMC_es,
    CategoriesMC: CategoriesMC_es,
    CalendarEventsScreenMC: CalendarEventsScreenMC_es,
    Quotes: Quotes_es
  },
  pt: {
    AuthMC: AuthMC_pt,
    BusinessConfigScreenMC: BusinessConfigScreenMC_pt,
    MyAccountScreenMC: MyAccountScreenMC_pt,
    ShippingScreenMC: ShippingScreenMC_pt,
    ShippingCostMC: ShippingCostMC_pt,
    translation: translation_pt,
    Common: CommonMC_pt,
    GetYourPlanScreen: GetYourPlanScreen_es,
    CallEvent: CallEvent_pt,
    Fonema: Fonema_pt,
    InboxMC: InboxMC_pt,
    Inbox: Inbox_pt,
    integrations: integrations_pt,
    BmVerificationMC: BmVerificationMC_pt,
    Products: Products_pt,
    ChatbotIA: ChatbotIA_pt,
    PaymentPlans: PaymentPlans_pt,
    CustomersScreenMC: CustomersScreenMC_pt,
    Quotes: Quotes_pt
  }
};
